import { Select as SelectPrimitive } from "@base-ui/react/select"

import SelectContent from "./SelectContent"
import SelectGroup from "./SelectGroup"
import SelectGroupLabel from "./SelectGroupLabel"
import SelectItem from "./SelectItem"
import SelectSeparator from "./SelectSeparator"
import SelectTrigger from "./SelectTrigger"
import SelectValue from "./SelectValue"

const Select = SelectPrimitive.Root

export {
  Select,
  SelectContent,
  SelectGroup,
  SelectGroupLabel,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
}
